showNotificationsModal().then();

async function showNotificationsModal() {
    const modalContainer = $('#notifications-modal');

    if (modalContainer.length < 1) {
        return;
    }

    const modalBody = modalContainer.find('.modal-body');
    const url = modalContainer.data('url');
    const markReadUrl = modalContainer.data('markReadUrl');

    const messages = await $.get(url);

    if (messages.length === 0) {
        return;
    }

    const messageIds = messages.map(x => x.uid);
    const messageTexts = messages.map(x => x.message);
    const messageDivs = messageTexts.map(messageText => '<div class="message-container">' + messageText + '</div>');

    const html = messageDivs.join('<div class="message-divider"></div>');

    modalBody.html(html);

    const okButton = modalContainer.find('.notifications-ok-button');

    okButton.off('click').on('click', function () {
        $.post(markReadUrl, {ids: messageIds});
    });

    modalContainer.modal({
        show: true,
        keyboard: false,
        backdrop: 'static',
    });
}